function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 14 11 C 6.28125 11 0 17.28125 0 25 C 0 32.71875 6.28125 39 14 39 L 36 39 C 43.71875 39 50 32.71875 50 25 C 50 17.28125 43.71875 11 36 11 Z M 14 13 C 20.640625 13 26 18.359375 26 25 C 26 31.640625 20.640625 37 14 37 C 7.359375 37 2 31.640625 2 25 C 2 18.359375 7.359375 13 14 13 Z M 21.15625 13 L 36 13 C 42.640625 13 48 18.359375 48 25 C 48 31.640625 42.640625 37 36 37 L 21.15625 37 C 25.242188 34.550781 28 30.097656 28 25 C 28 19.902344 25.242188 15.449219 21.15625 13 Z",
  fill: "#18181b"
});

var SvgToggleOff = function SvgToggleOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "#18181b",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToggleOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/toggleOff.56f47808.svg";
export { ForwardRef as ReactComponent };